import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { API_URL } from '../config';
import '../styles/AppDetails.css'; // Reuse existing details styles

interface MerchItem {
  id: string;
  name: string;
  price: number;
  description: string;
  image: string;
}

const MerchDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [item, setItem] = useState<MerchItem | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch from the API to get the latest items
    fetch(`${API_URL}/api/merchandise`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    })
      .then(res => res.json())
      .then(data => {
        const found = data.find((m: MerchItem) => m.id === id);
        setItem(found || null);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching merch details:', err);
        setLoading(false);
      });
  }, [id, token]);

  if (loading) return <div className="details-container"><div className="loading-state">Loading item details...</div></div>;
  if (!item) return <div className="details-container"><div className="no-results"><h2>Item not found</h2><button onClick={() => navigate('/shopping')} className="view-btn">Back to Shopping</button></div></div>;

  return (
    <ErrorBoundary>
      <div className="details-container">
        <button className="back-link" onClick={() => navigate('/shopping')}>← Back to Shopping</button>
        <div className="details-header">
          <div className="header-top">
            <div style={{ position: 'relative', width: '350px', height: '350px', backgroundColor: '#f9f9f9', borderRadius: '15px' }}>
              <img src={item.image} alt={item.name} className="details-icon" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '15px', boxShadow: 'none' }} />
              {/* SMALL LOGO IN THE CORNER - subtle branding */}
              <div style={{ 
                position: 'absolute', 
                top: '10px', 
                left: '10px', 
                width: '50px', 
                height: '50px', 
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                zIndex: 10
              }}>
                <img src="/logo.png" alt="FIND Logo" style={{ width: '80%', height: '80%' }} />
              </div>
            </div>
            <div className="header-info">
              <h1 className="details-name">{item.name}</h1>
              <p className="details-category">Shopping</p>
              <div className="details-meta">
                <span className="price-tag">${item.price}</span>
                <span style={{ color: '#e91e63', fontWeight: 'bold', marginLeft: '15px' }}>Cash on Delivery Only</span>
              </div>
            </div>
          </div>
        </div>

        <div className="details-section">
          <h3>Description</h3>
          <p className="description-text">{item.description}</p>
        </div>

        <div className="booking-footer">
          <button 
            className="book-btn" 
            onClick={() => navigate(`/checkout/${item.id}`)}
            style={{ width: '100%', padding: '15px', fontSize: '1.1rem' }}
          >
            Order Now - Pay on Delivery
          </button>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default MerchDetails;
